// link api
// export const BASE_API_URL = 'https://itp-mes-api.isdcorp.vn/api/v1';
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
// số item trên trang (mặc định)
export const PAGE_SIZE_DEFAULT = 10;

export const URL_PRINT = process.env.REACT_APP_BASE_URL + '/';

// url trang chủ MVC
// export const URL_HOME = 'https://itp-mes.isdcorp.vn';
export const URL_HOME = process.env.REACT_APP_BASE_URL;

export const CRYPTED_KEY = 'XJenBr2oWxP7UdBRSkyIo1mqB4O6UBs3';

//url module trang MVC
// export const URL_MODULE_MVC = 'https://itp-mes.isdcorp.vn/Module/';
export const URL_MODULE_MVC = process.env.REACT_APP_BASE_URL + '/Module/';
